// 企业管理
import {gql, useMutation, useSubscription} from "@apollo/client";
import {Button, DatePicker, Form, Input, Table} from "antd";

const {TextArea} = Input;


export default function Qygl() {
    const [insert_company, {error}] = useMutation(
        gql`
            mutation MyMutation($objects: [company_insert_input!] = {}) {
                insert_company(objects: $objects) {
                    returning {
                        updated_at
                        tyshxydm
                        qymc
                        qyjj
                        qyjc
                        id
                        created_at
                        clsj
                    }
                }
            }
        `);


    const columns = [
        {
            title: '企业名称',
            dataIndex: 'qymc',
            key: 'qymc',
        },
        {
            title: '统一社会信用代码',
            dataIndex: 'tyshxydm',
            key: 'tyshxydm',
        },
        {
            title: '成立时间',
            dataIndex: 'clsj',
            key: 'clsj',
            render: (_, recoder) => new Date(_).toLocaleDateString()
        }, {
            title: '企业简称',
            dataIndex: 'qyjc',
            key: 'qyjc',
        },
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'action',
            render: (_, record) => (
                <a onClick={(event) => {
                    window.location.hash = '/sbcl?' + _
                }}>申报材料</a>
            ),
        },
    ];

    const {data, loading} = useSubscription(
        gql`subscription MySubscription {
            company {
                clsj
                created_at
                id
                qymc
                tyshxydm
                updated_at
                qyjc
                qyjj
            }
        }`
    );

    return (<>
        <Form
            name="basic"
            labelCol={{span: 8}}
            wrapperCol={{span: 16}}
            style={{maxWidth: 600}}
            initialValues={{remember: true}}
            onFinish={(values) => {
                insert_company({
                        variables: {
                            objects: {
                                ...values,
                                'clsj': values['clsj'].toDate()
                            }
                        }
                    }
                )
            }
            }
            onFinishFailed={(e) => {
                console.error(e)
            }}
            autoComplete="off"
        >
            <Form.Item
                label="企业名称"
                name="qymc"
                rules={[{required: true, message: '请输入内容'}]}
            >
                <Input placeholder="例如：桂林伯爵电子科技有限公司"/>
            </Form.Item>
            <Form.Item
                label="企业简称"
                name="qyjc"
                rules={[{required: true, message: '请输入内容'}]}
            >
                <Input placeholder="例如：伯爵"/>
            </Form.Item>
            <Form.Item
                label="统一社会信用代码"
                name="tyshxydm"
                rules={[{required: true, message: '请输入内容'}]}
            >
                <Input placeholder="例如：91450303MA5NUK7T7B"/>
            </Form.Item>
            <Form.Item
                label="成立时间"
                name="clsj"
                rules={[{required: true, message: '请输入内容'}]}
            >
                <DatePicker/>
            </Form.Item>

            <Form.Item
                label="企业简介"
                name="qyjj"
                rules={[{required: true, message: '请输入内容'}]}
            >
                <TextArea showCount autoSize={{
                    minRows: 5,
                }}
                          placeholder="例如：桂林伯爵电子科技有限公司成立于2019年，是一家致力于研发、生产、销售电子产品的高科技企业。公司拥有一支高素质的研发团队，致力于为客户提供一流的电子产品及解决方案。公司总部位于中国广西桂林市，拥有先进的制造和测试设施。旗下产品线包括智能家居、智能手表、智能手机等多个领域。公司以不断创新的理念为支撑，率先运用人工智能、区块链等新兴科技，不断推陈出新，不断创造优秀的产品和作品。公司注重品质和服务，拥有完善的质量控制系统，生产出来的产品质量可靠，深受用户好评。公司始终秉承“以人为本、诚信共赢”的经营理念，注重员工发展与客户需求的平衡，以满足客户需求为己任，服务社会，是广大消费者值得信赖的品牌。"/>
            </Form.Item>

            <Form.Item wrapperCol={{offset: 8, span: 16}}>
                <Button type="primary" htmlType="submit">
                    添加
                </Button>
            </Form.Item>
        </Form>
        <Table columns={columns} dataSource={(data || []).company}/>
    </>)
}
